module.exports = __webpack_public_path__ + "static/GNT0-754e4e0906b0b20d138b4d6c06f63b8c.png";